import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ParametrizacionService } from '../../../services/parametrizacion.service';
import { FiltroParametrizacionDTO } from '../../../dto/expediente/parametrizacion.dto';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-modal-video',
  templateUrl: './modal-video.component.html',
  styleUrl: './modal-video.component.scss'
})
export class ModalVideoComponent implements OnInit {

  @ViewChild('modalVideo')
  modalVideo!: ElementRef;

  videoUrl: SafeResourceUrl | null = null;

  constructor(
    private parametrizacionService: ParametrizacionService,
    private sanitizer: DomSanitizer
  ) {}
  
  ngOnInit(): void {
    const userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    const userID = String(userData.idUsuario);
    if (userID !== 'undefined') {
      this.cargarUrlVideo();
    }
  }

  cargarUrlVideo(): void {
    const filtro: FiltroParametrizacionDTO = {
      pagina: 1,
      tamanoPagina: 100, // Aumentado para obtener todos los registros
      ordenarPor: 'descripcion',
      ordenarAsc: true,
      filtros: null
    };

    this.parametrizacionService.getUrlParametrizacion(filtro).subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data && response.data.registros) {
          const parametroVideo = response.data.registros.find(
            (param) => param.nombre_parametro === 'URL_VIDEO_JUSTINO'
          );
          
          if (parametroVideo && parametroVideo.valor_parametro) {
            // Convertir URL de YouTube watch a embed si es necesario
            let urlVideo = parametroVideo.valor_parametro;
            
            // Si es una URL de YouTube watch, convertirla a embed
            if (urlVideo.includes('youtube.com/watch')) {
              const videoId = urlVideo.split('v=')[1]?.split('&')[0];
              if (videoId) {
                urlVideo = `https://www.youtube.com/embed/${videoId}`;
              }
            }
            
            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlVideo);
          } else {
            console.warn('No se encontró el parámetro URL_VIDEO_JUSTINO');
          }
        }
      },
      error: (error) => {
        console.error('Error al cargar la URL del video:', error);
      }
    });
  }
  
  abrirCerrarModal() {
    this.modalVideo.nativeElement.click();
  }
}
